// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const selectClasses = {
  clearTrigger: "qui-select__clear-trigger",
  content: "qui-select__content",
  control: "qui-select__control",
  hiddenSelect: "qui-select__hidden-select",
  icon: "qui-select__icon",
  indicator: "qui-select__indicator",
  item: "qui-select__item",
  itemGroup: "qui-select__item-group",
  itemGroupLabel: "qui-select__item-group-label",
  itemIndicator: "qui-select__item-indicator",
  itemText: "qui-select__item-text",
  label: "qui-select__label",
  positioner: "qui-select__positioner",
  root: "qui-select__root",
  valueText: "qui-select__value-text",
} as const
